module.exports = __webpack_public_path__ + "static/media/wall_exit.ce56907f.png";